/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 品牌会员专享
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class FindCommoditiesMemberBrandParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  memberGradeId: string,

  params: FindCommoditiesMemberBrandParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.CommodityDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/commodities/member/brand/${memberGradeId}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
